import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const { pathname } = useLocation()
  const homeHref = pathname.startsWith('/emergency-plumbers')
    ? '/emergency-plumbers'
    : pathname.startsWith('/gas-safe-plumbers')
      ? '/gas-safe-plumbers'
      : pathname.startsWith('/water-safe-plumbers')
        ? '/water-safe-plumbers'
      : '/plumbers'

  return (
    <nav aria-label="Breadcrumb">
      <ol className="flex items-center gap-1 text-sm text-gray-500 flex-wrap list-none">
        <li>
          <Link to={homeHref} className="flex items-center gap-1 hover:text-gray-700 transition-colors">
            <Home className="h-3.5 w-3.5" />
            <span className="text-xs">UK</span>
          </Link>
        </li>
        {items.map((item, i) => {
          const isLast = i === items.length - 1
          return (
            <li key={i} className="flex items-center gap-1">
              <ChevronRight className="h-3.5 w-3.5 text-gray-300 flex-shrink-0" aria-hidden="true" />
              {item.href && !isLast ? (
                <Link to={item.href} className="hover:text-gray-700 transition-colors capitalize">
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-800 font-medium capitalize" aria-current="page">
                  {item.label}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
